import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var SlackOld = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M20.935 12.646a1.617 1.617 0 00-2.022-1.034l-1.632.532c-.355-1.099-.735-2.268-1.092-3.365l.006-.002-.004-.008 1.613-.523a1.62 1.62 0 001.035-2.023 1.62 1.62 0 00-2.025-1.034l-1.621.527-.519-1.604a1.619 1.619 0 00-2.024-1.034 1.618 1.618 0 00-1.033 2.024l.522 1.609-3.368 1.092-.524-1.611a1.618 1.618 0 00-2.022-1.034 1.617 1.617 0 00-1.034 2.023l.524 1.616-1.662.541a1.602 1.602 0 00-.988 1.95c.25.856 1.152 1.373 1.979 1.092.006 0 .658-.209 1.665-.536l1.099 3.386h-.002v.002l-1.67.545a1.599 1.599 0 00-.987 1.949c.25.857 1.15 1.374 1.979 1.093.007 0 .659-.211 1.665-.538l.003.005a.024.024 0 00.008-.002l.539 1.657a1.6 1.6 0 001.949.989c.857-.25 1.373-1.151 1.094-1.979 0-.006-.209-.654-.533-1.654l-.003-.009c1.104-.358 2.276-.739 3.376-1.098l.543 1.668a1.602 1.602 0 001.949.989c.856-.251 1.374-1.152 1.092-1.979 0-.007-.209-.659-.535-1.663l.019-.006-.003-.007 1.609-.522a1.62 1.62 0 001.035-2.024zM10.86 14.238l-1.097-3.377a.02.02 0 00.005-.001v-.006c1.098-.356 2.268-.735 3.363-1.092l1.098 3.377-3.369 1.099z",
    key: "k0"
  }));
});
SlackOld.displayName = 'SlackOld';
export var SlackOldDimensions = {
  height: 24,
  width: 24
};